export const deleteAccParam = () => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    const uid = getState().firebase.auth.uid;

    firestore
      .collection("users")
      .doc(uid)
      .update({
        deleted: true
      })
      .then(() => {
        dispatch({ type: "DELETE_PARAM_SUCCESS" });
      })
      .catch(err => {
        dispatch({ type: "DELETE_PARAM_ERROR", err });
      });
  };
};

export const deleteAcc = () => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firebase = getFirebase();
    const user = firebase.auth().currentUser;

    user
      .delete()
      .then(function() {
        dispatch({ type: "DELETE_USER_SUCCESS" });
      })
      .catch(function(error) {
        dispatch({ type: "DELETE_USER_ERROR", error });
      });
  };
};

export const resetDeleteVars = () => {
  return dispatch => {
    dispatch({ type: "RESET_DELETE_VARS" });
  };
};

export const reauthenticateUser = password => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    const email = getState().firebase.auth.email;

    const user = firebase.auth().currentUser;
    const credential = firebase.auth.EmailAuthProvider.credential(
      email,
      password
    );
    // Prompt the user to re-provide their sign-in credentials

    user
      .reauthenticateAndRetrieveDataWithCredential(credential)
      .then(function() {
        // User re-authenticated.
        dispatch({ type: "REAUTHENTICATE_SUCCESS" });
      })
      .catch(function(error) {
        // An error happened.
        dispatch({ type: "REAUTHENTICATE_ERROR", error });
      });
  };
};

export const reAuthWithFacebook = () => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const provider = new firebase.auth.FacebookAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(function(result) {
        if (result.credential) {
          // This gives you a Facebook Access Token. You can use it to access the Facebook API.
          const token = result.credential.accessToken;
          // ...
        }
        // The signed-in user info.
        const user = result.user;
        const uid = result.user.uid;
        dispatch({ type: "REAUTHENTICATE_FACE_SUCCESS" });
      })
      .catch(function(error) {
        console.log("Facebook login error: " + error);
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        const credential = error.credential;
        dispatch({ type: "REAUTHENTICATE_FACE_ERR", errorCode });
        // ...
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/deleteAction.tsx